import { Toaster } from "sonner";
import Navbar from "@/components/blocks/Navbar";
import HeroSection from "@/components/blocks/HeroSection";
import OperatorLogos from "@/components/blocks/OperatorLogos";
import ForWhom from "@/components/blocks/ForWhom";
import HowItWorks from "@/components/blocks/HowItWorks";
import Comparison from "@/components/blocks/Comparison";
import Realizations from "@/components/blocks/Realizations";
import Transparency from "@/components/blocks/Transparency";
import WhyUs from "@/components/blocks/WhyUs";
import OurPrinciples from "@/components/blocks/OurPrinciples";
import FAQ from "@/components/blocks/FAQ";
import FooterCTA from "@/components/blocks/FooterCTA";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import CookieBanner from "@/components/CookieBanner";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <a
        href="#hero-form"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-emerald-700 focus:text-white focus:px-4 focus:py-2 focus:rounded-full focus:shadow-lg"
      >
        Przejdź do formularza zgłoszenia
      </a>
      <Toaster position="top-center" richColors />
      <Navbar />
      <HeroSection />
      <OperatorLogos />
      <ForWhom />
      <HowItWorks />
      <Comparison />
      <Realizations />
      <Transparency />
      <WhyUs />
      <OurPrinciples />
      <FAQ />
      <FooterCTA />
      <StickyMobileCTA />
      <CookieBanner />
    </div>
  );
}
